/* Bahasa Indonesia. Generated from the Indonesian translation (scripts/i18n/indonesian); don't edit by hand. Translated from the English. */
import type { Dict } from './en';

export const idn: Dict = {
  "company.privacyEmail": "hello@pathsabroad.com",
  "company.supportEmail": "hello@pathsabroad.com",
  "app.skip": "Langsung ke konten utama",
  "app.home": "Beranda PathsAbroad",
  "lang.label": "Bahasa",
  "nav.sections": "Bagian akun",
  "nav.overview": "Ringkasan",
  "nav.profile": "Profil",
  "nav.inbox": "Kotak masuk pendaftaran",
  "nav.plans": "Paket",
  "nav.extension": "Ekstensi Chrome",
  "nav.security": "Masuk dan keamanan",
  "nav.data": "Data Anda",
  "nav.account": "Akun",
  "nav.planner": "Buka planner",
  "nav.signin": "Masuk",
  "nav.signout": "Keluar",
  "footer.privacy": "Privasi",
  "footer.terms": "Ketentuan",
  "footer.note": "Tanpa iklan, tanpa pelacakan. Hanya cookie yang menjaga Anda tetap masuk.",
  "common.loading": "Memuat…",
  "common.retry": "Coba lagi",
  "common.continue": "Lanjut",
  "common.cancel": "Batal",
  "common.save": "Simpan perubahan",
  "common.saving": "Menyimpan…",
  "common.copied": "Tersalin",
  "common.copyFailed": "Tidak dapat menyalin. Pilih teksnya lalu salin sendiri.",
  "common.show": "Tampilkan",
  "common.hide": "Sembunyikan",
  "common.showPassword": "Tampilkan kata sandi",
  "common.hidePassword": "Sembunyikan kata sandi",
  "common.optional": "opsional",
  "common.choose": "Pilih…",
  "common.remove": "Hapus",
  "common.removeNamed": "Hapus {name}",
  "common.email": "Email",
  "common.password": "Kata sandi",
  "common.on": "Aktif",
  "common.off": "Nonaktif",
  "common.opensNew": "(terbuka di tab baru)",
  "common.home": "Ke beranda",
  "session.checking": "Memeriksa sesi Anda…",
  "session.error": "Kami tidak dapat menghubungi PathsAbroad untuk memeriksa sesi Anda.",
  "err.bad_credentials": "Email dan kata sandi tersebut tidak cocok. Coba lagi, atau atur ulang kata sandi Anda.",
  "err.email_not_confirmed": "Konfirmasi email Anda terlebih dahulu dengan mengetik kode 6 digit yang kami kirim.",
  "err.bad_code": "Kode itu tidak berhasil. Periksa kembali dan coba lagi, atau minta kode baru.",
  "err.already_paid": "Anda sudah memiliki pass ini untuk musim ini.",
  "err.withdrawal_ack_required": "Centang kotak untuk menyatakan bahwa Anda memahami semua penjualan bersifat final, lalu coba lagi.",
  "err.version_conflict": "Ini telah berubah di tempat lain. Muat ulang halaman untuk melihat versi terbaru.",
  "err.invalid": "Beberapa data perlu diperiksa. Lihat kolom yang disorot.",
  "err.not_found": "Kami tidak dapat menemukannya. Mungkin sudah dihapus.",
  "err.rate_limited": "Terlalu banyak percobaan. Tunggu beberapa menit, lalu coba lagi.",
  "err.forbidden": "Ini tidak tersedia untuk akun Anda.",
  "err.network": "Tidak dapat menghubungi PathsAbroad. Periksa koneksi Anda dan coba lagi.",
  "err.server_error": "Terjadi masalah di pihak kami. Coba lagi sebentar lagi.",
  "err.signed_out": "Sesi Anda telah berakhir. Masuk lagi.",
  "err.mfa_required": "Ketik kode verifikasi dua langkah Anda terlebih dahulu.",
  "err.guardian_consent_required": "Orang tua atau wali perlu menyetujui akun Anda terlebih dahulu.",
  "err.plan_required": "Ini memerlukan pass Pendaftaran & Kedatangan.",
  "v.email": "Masukkan alamat email seperti name@example.com.",
  "v.password": "Gunakan minimal 10 karakter.",
  "v.passwordMatch": "Kata sandi tidak cocok.",
  "v.code": "Masukkan kode 6 digit.",
  "v.required": "Isi kolom ini.",
  "v.tick": "Centang kotak ini untuk melanjutkan.",
  "v.choose": "Pilih salah satu.",
  "pw.hint": "Minimal 10 karakter. Kalimat pendek mudah diingat dan sulit ditebak.",
  "pw.strength": "Kekuatan: {level}",
  "pw.too_short": "terlalu pendek",
  "pw.weak": "lemah",
  "pw.fair": "cukup",
  "pw.strong": "kuat",
  "home.title": "Kuliah di luar negeri, satu langkah jelas demi satu langkah.",
  "home.lead": "PathsAbroad membantu Anda menemukan universitas yang cocok, mendaftar dengan cara Anda sendiri, mempersiapkan visa dengan informasi resmi, dan menyesuaikan diri di tempat baru.",
  "home.start": "Temukan universitas Anda",
  "home.signin": "Masuk",
  "home.planner": "Buka planner",
  "home.pathTitle": "Perjalanan Anda",
  "home.step0.text": "Ceritakan tentang diri Anda sekali saja. Data Anda tetap milik Anda: unduh atau hapus kapan saja.",
  "home.step1.text": "Pilih universitas mana pun, termasuk yang tidak kami sarankan. Anda sendiri yang mengirim setiap pendaftaran dan membayar setiap biaya.",
  "home.step2.text": "Email penerimaan masuk ke satu kotak masuk, sudah dipilah, dengan langkah berikutnya yang sudah diambilkan untuk Anda.",
  "home.step3.text": "Daftar periksa visa dari sumber resmi, plus tempat tinggal dan minggu-minggu pertama Anda. Informasi umum, bukan nasihat imigrasi atau hukum.",
  "phase.0": "Profil",
  "phase.1": "Pendaftaran",
  "phase.2": "Diterima",
  "phase.3": "Kedatangan",
  "phase.here": "Anda di sini",
  "phase.done": "selesai",
  "phase.summary": "Langkah {n} dari 4: {name}",
  "auth.step": "Langkah {n} dari {total}",
  "auth.saveList": "Simpan daftar Anda",
  "auth.beginWith": "Dimulai dengan {school}",
  "auth.welcomeBack": "Selamat datang kembali",
  "start.dob.title": "Kapan Anda lahir?",
  "start.dob.day": "Tanggal",
  "start.dob.month": "Bulan",
  "start.dob.year": "Tahun",
  "dob.missing": "Pilih tanggal, bulan, dan tahun.",
  "dob.no_such_day": "Tanggal itu tidak ada. Periksa tanggal dan bulannya.",
  "dob.check": "Periksa tanggal lahir Anda.",
  "start.blocked.title": "Maaf, kami tidak dapat membuat akun PathsAbroad untuk Anda.",
  "start.form.title": "Buat akun Anda",
  "start.form.emailHint": "Kami akan mengirim kode untuk memastikan email ini milik Anda.",
  "start.form.lang": "Bahasa",
  "start.form.langHint": "Untuk aplikasi dan email yang kami kirim kepada Anda.",
  "start.form.minor": "Orang tua atau wali perlu menyetujui akun Anda sebelum Anda dapat menyimpan data Anda.",
  "start.form.agree": "Dengan membuat akun, Anda menyetujui {terms} dan menyatakan telah membaca {privacy}.",
  "start.form.termsLink": "Ketentuan penggunaan",
  "start.form.privacyLink": "Pemberitahuan privasi",
  "start.form.submit": "Buat akun",
  "start.form.changeDob": "Ubah tanggal lahir",
  "start.haveAccount": "Sudah punya akun?",
  "verify.title": "Periksa email Anda",
  "verify.sent": "Kami mengirim kode 6 digit ke {email}. Mungkin perlu satu menit untuk sampai.",
  "verify.noEmail": "Ketik email yang Anda pakai untuk mendaftar dan kode 6 digit yang kami kirim.",
  "verify.code": "Kode 6 digit",
  "verify.submit": "Verifikasi email",
  "verify.resend": "Kirim kode baru",
  "verify.resendIn": "Kirim kode baru dalam {time}",
  "verify.resent": "Kami mengirim kode baru ke {email}.",
  "verify.rateLimited": "Anda sudah meminta beberapa kode. Tunggu beberapa menit sebelum meminta lagi.",
  "verify.noResend": "Untuk mendapatkan kode baru, mulai lagi dari awal. Kami tidak menyimpan data pendaftaran Anda di browser ini.",
  "verify.startAgain": "Mulai lagi",
  "callback.title": "Memasukkan Anda",
  "callback.working": "Sebentar…",
  "callback.failed": "Tautan masuk ini tidak berhasil. Mungkin sudah kedaluwarsa atau sudah dipakai.",
  "callback.signin": "Ke halaman masuk",
  "signin.title": "Masuk",
  "signin.forgot": "Lupa kata sandi?",
  "signin.new": "Belum punya akun?",
  "signin.create": "Buat akun",
  "signin.enterCode": "Masukkan kode Anda",
  "code.title": "Masukkan kode masuk Anda",
  "code.lead": "Buka aplikasi autentikator Anda dan ketik kode 6 digit yang ditampilkan untuk PathsAbroad.",
  "code.label": "Kode 6 digit",
  "code.switch": "Gunakan akun lain",
  "code.help": "Ponsel hilang? Kirim email ke {email} dari alamat yang Anda pakai untuk mendaftar.",
  "reset.title": "Atur ulang kata sandi Anda",
  "reset.lead": "Ketik email yang Anda pakai untuk PathsAbroad. Kami akan mengirimkan kode 6 digit.",
  "reset.send": "Kirim kode",
  "reset.sent": "Jika ada akun untuk {email}, kami telah mengirim kode 6 digit ke alamat itu.",
  "reset.newPassword": "Kata sandi baru",
  "reset.submit": "Atur kata sandi baru",
  "reset.otherEmail": "Gunakan email lain",
  "reset.back": "Kembali ke halaman masuk",
  "gn.title": "Orang tua atau wali perlu menyetujui",
  "gn.lead": "Karena Anda berusia di bawah 18 tahun, orang tua atau wali perlu setuju sebelum PathsAbroad menyimpan apa pun tentang Anda, seperti profil, daftar universitas, atau dokumen Anda.",
  "gn.whatTitle": "Yang mereka setujui",
  "gn.what1": "Bahwa PathsAbroad dapat menyimpan profil Anda dan memakainya untuk membantu pendaftaran Anda.",
  "gn.what2": "Bahwa Anda dapat memakai planner, kotak masuk pendaftaran, dan ekstensi Chrome.",
  "gn.what3": "Kami tidak akan menanyakan data sensitif seperti agama atau pendapatan keluarga selama Anda berusia di bawah 18 tahun.",
  "gn.howTitle": "Cara kerjanya",
  "gn.how1": "Kami mengirim tautan ke alamat email yang Anda ketik di bawah.",
  "gn.how2": "Halaman itu menjelaskan apa yang kami simpan dan alasannya. Mereka dapat setuju atau menolak.",
  "gn.how3": "Jika mereka setuju, akun Anda terbuka sepenuhnya. Mereka dapat berubah pikiran nanti, dan itu akan menghapus akun Anda.",
  "gn.whyTitle": "Mengapa kami meminta ini",
  "gn.why": "Hukum di banyak negara melindungi orang di bawah 18 tahun saat online. Melibatkan orang tua atau wali membuat Anda berdua tetap mengetahui perkembangannya.",
  "gn.formTitle": "Kirim permintaan",
  "gn.email": "Email orang tua atau wali",
  "gn.lang": "Bahasa untuk email mereka",
  "gn.submit": "Kirim permintaan",
  "gn.sameEmail": "Gunakan email milik orang tua atau wali Anda sendiri, bukan email Anda.",
  "gn.sent": "Permintaan dikirim ke {email}.",
  "gn.rateLimited": "Anda dapat mengirim hingga 3 permintaan per hari. Coba lagi besok.",
  "gn.pending.title": "Menunggu jawaban",
  "gn.pending.text": "Kami telah mengirim email ke orang tua atau wali Anda. Tautannya berlaku selama 14 hari, dan halaman ini diperbarui dengan sendirinya.",
  "gn.check": "Periksa sekarang",
  "gn.resend": "Kirim lagi",
  "gn.granted.title": "Orang tua atau wali Anda setuju",
  "gn.granted.text": "Akun Anda sudah siap. Sekarang Anda dapat menyimpan profil dan memakai semua fitur di PathsAbroad.",
  "gn.granted.go": "Ke akun Anda",
  "gn.denied.title": "Orang tua atau wali Anda menolak",
  "gn.denied.text": "Anda dapat berbicara dengan mereka dan mengirim permintaan baru, atau meminta orang tua atau wali lain.",
  "gn.expired.title": "Tautan kedaluwarsa",
  "gn.expired.text": "Tidak ada yang menjawab dalam 14 hari. Anda dapat mengirim permintaan baru di bawah.",
  "gn.revoked.title": "Persetujuan dicabut",
  "gn.revoked.text": "Orang tua atau wali Anda mencabut persetujuan mereka.",
  "gn.limited": "Sampai saat itu, Anda dapat membaca pemberitahuan privasi dan ketentuan penggunaan kami, atau keluar.",
  "gc.title": "Seorang pelajar meminta persetujuan Anda",
  "gc.lead": "{student} ingin memakai PathsAbroad. Karena berusia di bawah 18 tahun, kami memerlukan persetujuan orang tua atau wali hukum terlebih dahulu.",
  "gc.aboutTitle": "Apa itu PathsAbroad",
  "gc.about": "PathsAbroad membantu pelajar memilih universitas di luar negeri, menyiapkan pendaftaran, mempersiapkan visa dengan informasi dari sumber resmi, dan menyesuaikan diri di tempat baru. Pelajar sendiri yang mengirim setiap pendaftaran dan membayar biaya universitas. PathsAbroad bukan universitas, agen, atau konsultan imigrasi.",
  "gc.storeTitle": "Yang kami simpan tentang pelajar",
  "gc.store1": "Profil mereka untuk pendaftaran: nama, tanggal lahir, kewarganegaraan, kontak, sekolah dan nilai, data keluarga, dan rencana studi. Tanggal lahir, kewarganegaraan, dan nomor paspor (jika ada) dienkripsi.",
  "gc.store2": "Data sensitif seperti etnis, agama, atau pendapatan keluarga: tidak pernah selama mereka berusia di bawah 18 tahun. Setelah berusia 18 tahun, mereka dapat memilih menambahkan masing-masing secara terpisah, hanya untuk pencocokan beasiswa.",
  "gc.store3": "Ringkasan kotak masuk: jika mereka memakai kotak masuk pendaftaran PathsAbroad, kami menyimpan ringkasan singkat email penerimaan. Pesan lengkap disimpan selama pass mereka berlaku, dan minimal 30 hari, lalu dihapus.",
  "gc.store4": "Pembayaran: jika paket berbayar dibeli, Stripe yang menangani data kartu. Kami tidak pernah melihat nomor kartu.",
  "gc.store5": "Tanpa iklan, tanpa pelacakan, dan kami tidak pernah menjual data.",
  "gc.rightsTitle": "Hak Anda",
  "gc.rights1": "Melihat atau mengunduh data pelajar, atau meminta kami memperbaiki atau menghapusnya, dengan mengirim email ke {email}.",
  "gc.rights2": "Mencabut persetujuan Anda kapan saja. Setelah Anda setuju, kami akan mengirim tautan terpisah untuk ini lewat email. Pencabutan akan menghapus akun dan data pelajar.",
  "gc.rights3": "Mengajukan keluhan ke otoritas perlindungan data di negara Anda jika Anda merasa ada yang kami lakukan dengan keliru.",
  "gc.formTitle": "Keputusan Anda",
  "gc.name": "Nama lengkap Anda",
  "gc.relationship": "Hubungan Anda dengan pelajar",
  "gc.confirm": "Saya adalah orang tua atau wali hukum pelajar ini dan saya berusia 18 tahun atau lebih",
  "gc.agree": "Setuju",
  "gc.decline": "Tolak",
  "gc.ignore": "Bukan orang yang tepat? Anda dapat mengabaikan permintaan ini. Permintaan ini berakhir pada {date}.",
  "gc.missing": "Halaman ini memerlukan tautan dari email yang kami kirim.",
  "gc.invalid.title": "Tautan ini tidak valid",
  "gc.invalid.text": "Mungkin sudah digantikan oleh permintaan yang lebih baru. Minta pelajar mengirim yang baru.",
  "gc.granted.title": "Terima kasih. Anda setuju.",
  "gc.granted.text": "{student} sekarang dapat memakai PathsAbroad. Kami telah mengirim tautan terpisah lewat email yang dapat Anda pakai untuk mencabut persetujuan kapan saja.",
  "gc.denied.title": "Anda menolak",
  "gc.denied.text": "PathsAbroad tidak akan menyimpan apa pun lagi tentang pelajar. Akun mereka tetap terbatas kecuali orang tua atau wali menyetujui.",
  "gc.already.granted": "Anda sudah menyetujui permintaan ini. Untuk mencabut persetujuan, gunakan tautan di email yang kami kirim setelah Anda setuju.",
  "gc.already.denied": "Anda sudah menolak permintaan ini.",
  "gc.already.expired": "Permintaan ini sudah kedaluwarsa. Pelajar dapat mengirim yang baru.",
  "gc.already.revoked": "Persetujuan untuk akun ini telah dicabut.",
  "gw.title": "Cabut persetujuan Anda",
  "gw.lead": "Jika Anda mencabut persetujuan, kami menghapus akun PathsAbroad pelajar dan seluruh datanya: profil, daftar universitas, esai, kotak masuk pendaftaran, pesan, dan tugas. Tindakan ini tidak dapat dibatalkan.",
  "gw.kept": "Stripe menyimpan catatan pembayaran selama diwajibkan oleh hukum pajak. Kami menyimpan catatan bahwa akun telah dihapus, tanpa data pribadi.",
  "gw.confirm": "Saya memahami bahwa ini menghapus akun dan data pelajar",
  "gw.submit": "Cabut persetujuan dan hapus akun",
  "gw.done.title": "Persetujuan dicabut",
  "gw.done.text": "Kami telah menghapus akun dan data pelajar, dan mengirim email konfirmasi kepada Anda berdua.",
  "gw.invalid": "Tautan ini tidak valid atau sudah dipakai.",
  "rel.mother": "Ibu",
  "rel.father": "Ayah",
  "rel.guardian": "Wali hukum",
  "rel.other": "Lainnya",
  "edu.none": "Tidak bersekolah formal",
  "edu.primary": "Sekolah dasar",
  "edu.secondary": "Sekolah menengah",
  "edu.some_university": "Pernah kuliah",
  "edu.bachelor": "Sarjana (S1)",
  "edu.master": "Magister (S2)",
  "edu.doctorate": "Doktor (S3)",
  "edu.unknown": "Tidak tahu",
  "acct.greeting": "Halo, {name}",
  "acct.greetingNoName": "Selamat datang kembali",
  "acct.hero.title": "Lanjutkan dari terakhir Anda berhenti",
  "acct.hero.text": "Daftar universitas, daftar periksa visa, dan pelacak pendanaan Anda ada di planner.",
  "acct.status": "Status",
  "acct.consent": "Persetujuan orang tua atau wali",
  "acct.consentGranted": "Disetujui",
  "acct.freePlan": "Paket Gratis",
  "acct.seePlans": "Lihat paket",
  "acct.pass": "Pass {plan}",
  "acct.validUntil": "Berlaku sampai {date}",
  "acct.mfa": "Verifikasi dua langkah",
  "acct.mfaNudge": "Kami menyarankan mengaktifkan verifikasi dua langkah, agar kata sandi yang dicuri saja tidak cukup untuk masuk ke akun Anda.",
  "acct.inbox": "Kotak masuk pendaftaran",
  "acct.inboxNone": "Dapatkan alamat Anda",
  "acct.withApply": "Termasuk dalam paket Pendaftaran & Kedatangan",
  "acct.extension": "Ekstensi Chrome",
  "acct.extensionOn": "Terhubung",
  "acct.extensionAdd": "Tambahkan ke Chrome",
  "acct.extensionSetUp": "Siapkan",
  "acct.you": "Akun Anda",
  "acct.groupApply": "Mendaftar",
  "acct.groupYou": "Anda dan paket Anda",
  "acct.groupSafety": "Privasi dan keamanan",
  "acct.groupPlanner": "Di planner",
  "acct.profileSub": "Data Anda, diisikan ke pendaftaran Anda",
  "acct.familySub": "Halaman perkembangan untuk orang tua, dan orang tua yang membayar",
  "acct.dataSub": "Unduh atau hapus semuanya",
  "acct.mfaShort": "Dua langkah",
  "acct.tools": "Alat dan pengaturan",
  "acct.toolsSub": "Rencana studi, dokumen, tanggal, latihan bahasa, dan tampilan terang atau gelap",
  "portal.label": "Utama",
  "portal.home": "Beranda",
  "portal.explore": "Jelajahi",
  "portal.apply": "Pendaftaran",
  "portal.account": "Akun",
  "acct.apps": "Pendaftaran",
  "acct.appsEmpty": "Pendaftaran Anda muncul di sini setelah Anda menambahkan universitas di planner.",
  "acct.submitted": "Dikirim {date}",
  "acct.tasks": "Yang harus dikerjakan",
  "acct.tasksEmpty": "Tidak ada yang perlu dikerjakan sekarang.",
  "acct.due": "Tenggat {date}",
  "acct.manage": "Akun Anda",
  "acct.loadError": "Bagian ini tidak dapat dimuat. {retry}",
  "task.ai": "AI",
  "task.aiFull": "Disarankan oleh AI",
  "task.email": "Dari kotak masuk Anda",
  "task.error": "Tugas ini tidak dapat diperbarui. Coba lagi.",
  "app.planned": "Direncanakan",
  "app.in_progress": "Sedang dikerjakan",
  "app.submitted": "Terkirim",
  "app.decision_admitted": "Diterima",
  "app.decision_denied": "Tidak diterima",
  "app.decision_waitlisted": "Daftar tunggu",
  "app.decision_deferred": "Ditunda",
  "app.accepted": "Tawaran diterima",
  "app.declined": "Tawaran ditolak",
  "app.withdrawn": "Ditarik",
  "profile.title": "Profil",
  "profile.lead": "Isi sekali saja. Ekstensi memakainya untuk mengisi portal pendaftaran, dan Anda memeriksa semuanya sebelum mengirim.",
  "profile.sec.name": "Nama Anda",
  "profile.nameNote": "Tulis nama Anda persis seperti yang tertera di paspor.",
  "f.given_name": "Nama depan",
  "f.middle_name": "Nama tengah",
  "f.family_name": "Nama keluarga",
  "f.preferred_name": "Nama panggilan",
  "profile.sec.about": "Tentang Anda",
  "f.dob": "Tanggal lahir",
  "f.gender": "Jenis kelamin",
  "gender.female": "Perempuan",
  "gender.male": "Laki-laki",
  "gender.another": "Gender lain",
  "gender.none": "Pilih untuk tidak menyebutkan",
  "profile.sec.citizenship": "Kewarganegaraan dan tempat tinggal",
  "f.citizenship1": "Kewarganegaraan",
  "f.citizenship2": "Kewarganegaraan kedua",
  "f.birth_country": "Negara kelahiran",
  "f.home_country": "Negara tempat Anda tinggal",
  "f.home_countryHint": "Harga dan daftar periksa visa memakai data ini.",
  "f.first_language": "Bahasa ibu",
  "profile.sec.contact": "Kontak",
  "f.phone": "Telepon",
  "f.phoneHint": "Sertakan kode negara Anda, seperti ⁦+971⁩.",
  "f.line1": "Alamat baris 1",
  "f.line2": "Alamat baris 2",
  "f.city": "Kota",
  "f.region": "Negara bagian, provinsi, atau wilayah",
  "f.postal_code": "Kode pos",
  "f.country": "Negara",
  "profile.sec.study": "Yang ingin Anda pelajari",
  "f.level": "Jenjang",
  "level.foundation": "Tahun persiapan (foundation)",
  "level.diploma": "Diploma atau sertifikat",
  "level.bachelor": "Sarjana (S1)",
  "level.master": "Magister (S2)",
  "level.phd": "S3 (PhD)",
  "f.field": "Bidang studi atau jurusan",
  "f.start_term": "Kapan Anda ingin mulai",
  "term.label": "{month} {year}",
  "f.budget_usd": "Anggaran per tahun dalam dolar AS",
  "f.budgetHint": "Biaya kuliah dan biaya hidup digabung.",
  "profile.sec.english": "Bahasa Inggris",
  "f.english_first": "Bahasa Inggris adalah bahasa ibu saya",
  "f.english_type": "Tes bahasa Inggris",
  "test.none": "Belum mengikuti",
  "test.other": "Tes lain",
  "f.english_score": "Skor",
  "f.english_date": "Tanggal tes",
  "profile.sec.passport": "Paspor",
  "f.passport_number": "Nomor paspor",
  "f.passportHint": "Opsional. Disimpan terenkripsi. Ekstensi tidak pernah mengisinya.",
  "profile.sec.family": "Keluarga",
  "profile.familyLead": "Portal pendaftaran sering menanyakan tentang orang tua atau wali Anda.",
  "profile.familyItem": "Orang tua atau wali {n}",
  "f.member_name": "Nama",
  "f.relation": "Hubungan",
  "f.education": "Pendidikan tertinggi",
  "f.occupation": "Pekerjaan",
  "profile.familyAdd": "Tambahkan orang tua atau wali",
  "profile.sec.schools": "Sekolah",
  "profile.schoolsLead": "Sekolah menengah Anda dan universitas mana pun yang pernah Anda ikuti.",
  "profile.schoolItem": "Sekolah {n}",
  "f.school_name": "Nama sekolah",
  "f.start_date": "Mulai",
  "f.end_date": "Selesai, atau perkiraan selesai",
  "f.test_type": "Ujian akhir atau kualifikasi",
  "f.test_typeHint": "Misalnya WAEC, CBSE, IGCSE, atau Tawjihi.",
  "f.test_score": "Hasil",
  "profile.schoolAdd": "Tambahkan sekolah",
  "profile.schoolNameRequired": "Tambahkan nama sekolah, atau hapus sekolah ini.",
  "profile.sec.sensitive": "Pencocokan beasiswa",
  "profile.sensitiveLead": "Opsional. Sebagian beasiswa hanya untuk pelajar dengan latar belakang tertentu. Anda dapat memilih membagikan masing-masing secara terpisah.",
  "profile.sensitivePurpose": "Hanya dipakai untuk mencocokkan Anda dengan beasiswa yang memintanya. Tidak pernah dikirim ke portal pendaftaran, tidak pernah dipakai untuk pemasaran.",
  "profile.consent.race": "Gunakan ras atau etnis saya untuk pencocokan beasiswa",
  "profile.consent.religion": "Gunakan agama saya untuk pencocokan beasiswa",
  "profile.consent.family_income": "Gunakan pendapatan keluarga saya untuk pencocokan beasiswa",
  "f.race": "Ras atau etnis",
  "f.religion": "Agama",
  "f.family_income": "Pendapatan keluarga per tahun dalam dolar AS",
  "income.lt10k": "Di bawah $10,000",
  "income.10k_25k": "$10,000 sampai $25,000",
  "income.25k_50k": "$25,000 sampai $50,000",
  "income.50k_100k": "$50,000 sampai $100,000",
  "income.gt100k": "Di atas $100,000",
  "profile.sensitiveCleared": "Ini akan dihapus saat Anda menyimpan.",
  "profile.sensitiveMinor": "Tidak tersedia untuk pelajar di bawah 18 tahun.",
  "profile.sec.lang": "Bahasa",
  "f.lang": "Bahasa untuk email",
  "profile.saved": "Profil Anda tersimpan.",
  "profile.unsaved": "Ada perubahan yang belum disimpan.",
  "inbox.title": "Kotak masuk pendaftaran",
  "inbox.lead": "Alamat email khusus Anda untuk pendaftaran. Email penerimaan yang dikirim ke sini dipilah di sini, dengan tanggal dan langkah berikutnya yang sudah diambilkan. Saat universitas mengirim keputusan atau meminta sesuatu, kami mengirim email kepada Anda.",
  "inbox.upsellTitle": "Termasuk dalam paket Pendaftaran & Kedatangan",
  "inbox.upsellText": "Dengan paket Pendaftaran & Kedatangan, Anda mendapat alamat PathsAbroad untuk dipakai di portal pendaftaran, dan setiap email penerimaan dipilah di satu tempat.",
  "inbox.seePlans": "Lihat paket",
  "inbox.address": "Alamat kotak masuk Anda",
  "inbox.copy": "Salin alamat",
  "inbox.howTitle": "Di mana memakainya",
  "inbox.how1": "Pakai sebagai alamat email Anda di portal pendaftaran, seperti Common App. Ekstensi PathsAbroad mengisikannya untuk Anda.",
  "inbox.how2": "Tetap pakai email Anda sendiri untuk keperluan lainnya.",
  "inbox.how3": "Pesan lengkap disimpan selama pass Anda berlaku, dan minimal 30 hari. Setelah itu kami menyimpan ringkasan singkat, tanggal, tautan, dan tindakan. Kami tidak menyimpan lampiran, jadi unduh dokumen dari portal universitas.",
  "inbox.messages": "Pesan",
  "inbox.empty": "Belum ada email penerimaan. Email akan muncul di sini begitu ada yang masuk.",
  "inbox.received": "Diterima {date}",
  "inbox.dates": "Tanggal",
  "inbox.links": "Tautan",
  "inbox.actions": "Yang harus dilakukan",
  "inbox.viewFull": "Lihat pesan lengkap",
  "inbox.hideFull": "Sembunyikan pesan lengkap",
  "inbox.fullGone": "Pesan lengkap sudah dihapus.",
  "inbox.fullExpires": "Pesan lengkap ini akan dihapus pada {date}.",
  "inbox.from": "Dari",
  "inbox.subject": "Subjek",
  "cat.decision": "Keputusan",
  "cat.interview_invite": "Wawancara",
  "cat.missing_documents": "Dokumen belum lengkap",
  "cat.financial_aid": "Bantuan keuangan",
  "cat.portal_credentials": "Login portal",
  "cat.submission_confirmation": "Terkirim",
  "cat.housing": "Tempat tinggal",
  "cat.visa_documents": "Dokumen visa",
  "cat.other": "Lainnya",
  "decision.admitted": "Diterima",
  "decision.denied": "Tidak diterima",
  "decision.waitlisted": "Daftar tunggu",
  "decision.deferred": "Ditunda",
  "plans.title": "Paket",
  "plans.lead": "Satu kali pembayaran per musim. Tanpa langganan.",
  "plans.oneTime": "Pembayaran satu kali untuk musim ini. Tanpa perpanjangan otomatis.",
  "plans.validFor": "Berlaku {months} sejak hari Anda membayar.",
  "plans.free": "Yang Anda miliki sekarang",
  "plans.freeTitle": "Semuanya gratis",
  "plans.freeLead": "Semua yang ada di PathsAbroad gratis untuk Anda. Universitas dan layanan mahasiswa membayar kami saat seorang pelajar mendaftar atau bergabung, bukan pelajar.",
  "plans.get": "Dapatkan {plan}",
  "plans.owned": "Anda memilikinya sampai {date}",
  "plans.ownedNoDate": "Anda memilikinya",
  "plans.bundlePartial": "Anda sudah memiliki {plan}. Pendaftaran & Kedatangan menambahkan semua yang lain.",
  "plans.redirecting": "Mengarahkan Anda ke pembayaran yang aman…",
  "plans.refund": "Semua penjualan bersifat final: tidak ada pengembalian dana. Jika Anda tidak mendapat tawaran, pass Anda berlanjut ke musim berikutnya.",
  "plans.startNowTitle": "Sebelum Anda membeli",
  "plans.startNow": "Mulai pass saya segera setelah saya membayar. Saya memahami bahwa semua penjualan bersifat final: setelah dimulai, saya tidak dapat membatalkannya atau mendapat pengembalian dana.",
  "plans.startNowNote": "Jika Anda tidak mendapat tawaran, pass Anda berlanjut ke musim berikutnya, gratis.",
  "plans.prices": "Harga dalam dolar AS, ditetapkan sesuai tempat Anda tinggal dan negara paspor Anda (kelompok harga {tier}).",
  "plans.noFees": "PathsAbroad tidak pernah memungut biaya universitas, tes, atau visa. Anda membayarnya sendiri, langsung.",
  "plans.paidTitle": "Terima kasih. Pembayaran Anda berhasil.",
  "plans.paidWaiting": "Kami sedang menambahkan pass Anda. Biasanya hanya butuh beberapa detik.",
  "plans.paidReady": "Pass {plan} Anda sudah siap.",
  "plans.paidEmail": "Email konfirmasi sedang dalam perjalanan.",
  "plans.paidSlow": "Ini memakan waktu lebih lama dari biasanya. Pembayaran Anda aman, dan pass Anda akan segera muncul di sini. Muat ulang halaman ini satu menit lagi.",
  "plans.canceled": "Pembayaran dibatalkan. Anda tidak dikenai biaya.",
  "plans.receipts": "Tanda terima dan faktur",
  "plans.yourPasses": "Pass Anda",
  "plans.choose": "Pilih paket",
  "pass.active": "Aktif",
  "pass.expired": "Kedaluwarsa",
  "pass.refunded": "Dana dikembalikan",
  "pass.canceled": "Dibatalkan",
  "pass.paidOn": "Dibayar {date}",
  "pass.validUntil": "Berlaku sampai {date}",
  "pass.withdrawUntil": "Anda dapat membatalkan untuk mendapat pengembalian dana penuh sampai {date}.",
  "pass.withdraw": "Batalkan kontrak di sini",
  "pass.confirmTitle": "Batalkan kontrak ini?",
  "pass.confirmRefund": "Anda mendapat pengembalian dana penuh ke metode pembayaran awal Anda.",
  "pass.confirmAccess": "Akses Anda ke {plan} berakhir sekarang.",
  "pass.confirmReceipt": "Kami akan mengirim tanda terima bertanggal lewat email.",
  "pass.confirm": "Konfirmasi pembatalan",
  "pass.keep": "Pertahankan pass saya",
  "pass.withdrawn": "Dana dikembalikan pada {date}. Pengembalian dana sedang dikirim ke metode pembayaran awal Anda.",
  "pass.withdrawOver": "Semua penjualan bersifat final: pass ini tidak dapat dibatalkan atau dikembalikan dananya.",
  "ai.tag": "AI",
  "ai.tagFull": "Memakai AI",
  "ext.title": "Ekstensi Chrome",
  "ext.lead": "Ekstensi PathsAbroad mengisi jawaban tersimpan Anda di portal pendaftaran, jadi Anda cukup mengetiknya sekali.",
  "ext.upsell": "Ekstensi ini termasuk dalam paket Pendaftaran & Kedatangan.",
  "ext.howTitle": "Cara kerjanya",
  "ext.how1": "Tambahkan ke Chrome dari Chrome Web Store. Hanya perlu satu klik.",
  "ext.how2": "Ekstensi terhubung dengan sendirinya selama Anda masuk ke PathsAbroad di browser yang sama, dan terputus saat Anda keluar.",
  "ext.how3": "Di halaman pendaftaran Anda, tekan “Isi dengan PathsAbroad”. Periksa setiap kolom, lalu kirim sendiri.",
  "ext.checking": "Mencari ekstensi…",
  "ext.connecting": "Menghubungkannya ke akun Anda…",
  "ext.addTitle": "Tambahkan PathsAbroad ke Chrome",
  "ext.addText": "Satu klik di Chrome Web Store, dan ekstensi terhubung ke akun Anda dengan sendirinya. Tidak ada kode untuk diketik.",
  "ext.addButton": "Tambahkan ke Chrome",
  "ext.addSoon": "Ekstensi akan segera tersedia di Chrome Web Store.",
  "ext.browsers": "Berfungsi di Chrome, Edge, Brave, dan browser lain berbasis Chromium, di komputer.",
  "ext.onTitle": "Terhubung di browser ini",
  "ext.onText": "Buka pendaftaran Anda di Common App, UCAS, OUAC, atau uni-assist dan tekan “Isi dengan PathsAbroad” di bagian bawah halaman.",
  "ext.onInstalled": "PathsAbroad terpasang dan terhubung.",
  "ext.onBack": "Sekarang Anda dapat kembali ke pendaftaran Anda.",
  "ext.connected": "Terhubung",
  "ext.errTitle": "Ekstensi tidak terhubung",
  "ext.errText": "Coba lagi. Jika masih tidak terhubung, gunakan kode pemasangan (di bawah).",
  "ext.retry": "Coba lagi",
  "ext.phoneTitle": "Di ponsel, gunakan aplikasi PathsAbroad",
  "ext.phoneText": "Aplikasi membuka pendaftaran Anda di dalamnya dan mengisinya untuk Anda. Di komputer, tambahkan ekstensi ke Chrome.",
  "ext.appStore": "Unduh di App Store",
  "ext.playStore": "Dapatkan di Google Play",
  "ext.appSoon": "Aplikasi akan segera tersedia di App Store dan Google Play.",
  "ext.otherTitle": "Buka PathsAbroad di Chrome atau Edge",
  "ext.otherText": "Ekstensi berfungsi di Chrome, Edge, dan browser lain berbasis Chromium. Buka PathsAbroad di salah satunya untuk menambahkannya.",
  "ext.inAppTitle": "Anda berada di aplikasi PathsAbroad",
  "ext.inAppText": "Buka pendaftaran Anda dari planner. Pendaftaran terbuka di dalam aplikasi, dengan tombol “Isi dengan PathsAbroad”. Anda tidak memerlukan ekstensi di sini.",
  "ext.fillButton": "Isi dengan PathsAbroad",
  "ext.codeTitle": "Hubungkan dengan kode",
  "ext.codeLead": "Hanya jika tidak terhubung dengan sendirinya",
  "ext.step2": "Klik “Dapatkan kode pemasangan” di bawah.",
  "ext.step3": "Buka ekstensi dan ketik kode dalam 10 menit.",
  "ext.getCode": "Dapatkan kode pemasangan",
  "ext.newCode": "Dapatkan kode baru",
  "ext.code": "Kode pemasangan Anda",
  "ext.copy": "Salin kode",
  "ext.expiresIn": "Berakhir dalam {time}",
  "ext.expired": "Kode ini sudah kedaluwarsa. Dapatkan yang baru.",
  "ext.oneUse": "Setiap kode hanya berlaku sekali.",
  "ext.minuteLeft": "Tersisa satu menit untuk memakai kode ini.",
  "ext.rulesTitle": "Yang dilakukan dan tidak dilakukan ekstensi",
  "ext.rule1": "Ekstensi mengisi jawaban tersimpan Anda di portal pendaftaran yang didukung: Common App, UCAS, OUAC, dan uni-assist.",
  "ext.ruleEmail": "Untuk email Anda, ekstensi mengisi alamat kotak masuk PathsAbroad Anda, sehingga email dari universitas masuk ke kotak masuk pendaftaran Anda.",
  "ext.rule2": "Anda memeriksa setiap kolom, dan Anda yang mengirim.",
  "ext.rule3": "Ekstensi tidak pernah mengisi esai atau kata sandi.",
  "ext.rule4": "Ekstensi tidak pernah mengklik kirim atau bayar.",
  "ext.rule5": "Ekstensi tidak aktif di situs visa dan situs pemerintah.",
  "ext.notAffiliated": "PathsAbroad tidak berafiliasi dengan Common App, UCAS, OUAC, uni-assist, atau universitas mana pun.",
  "sec.title": "Masuk dan keamanan",
  "sec.mfaTitle": "Verifikasi dua langkah",
  "sec.mfaOffText": "Saat aktif, Anda mengetik kode dari aplikasi autentikator setiap kali masuk, sehingga kata sandi yang dicuri saja tidak cukup.",
  "sec.mfaOnText": "Anda mengetik kode dari aplikasi autentikator setiap kali masuk.",
  "sec.mfaTurnOn": "Aktifkan verifikasi dua langkah",
  "sec.mfaStep1": "Pasang aplikasi autentikator, seperti Google Authenticator, Microsoft Authenticator, atau 1Password.",
  "sec.mfaStep2": "Pindai kode QR ini dengan aplikasinya.",
  "sec.mfaQr": "Kode QR untuk aplikasi autentikator Anda",
  "sec.mfaOpenApp": "Di ponsel ini? Buka di aplikasi autentikator Anda",
  "sec.mfaKey": "Tidak bisa memindai? Ketik kunci ini ke aplikasi:",
  "sec.mfaCopyKey": "Salin kunci",
  "sec.mfaStep3": "Ketik kode 6 digit yang ditampilkan aplikasi.",
  "sec.mfaVerify": "Aktifkan",
  "sec.mfaEnabled": "Verifikasi dua langkah aktif.",
  "sec.mfaTurnOff": "Nonaktifkan",
  "sec.mfaConfirmOff": "Nonaktifkan verifikasi dua langkah? Kata sandi saja kemudian sudah cukup untuk masuk.",
  "sec.mfaKeepOn": "Tetap aktifkan",
  "sec.mfaDisabled": "Verifikasi dua langkah nonaktif.",
  "sec.pwTitle": "Kata sandi",
  "sec.pwNew": "Kata sandi baru",
  "sec.pwConfirm": "Ketik lagi",
  "sec.pwSubmit": "Ubah kata sandi",
  "sec.pwDone": "Kata sandi Anda telah diubah.",
  "sec.signoutTitle": "Keluar",
  "sec.signoutText": "Keluar dari PathsAbroad di browser ini.",
  "data.title": "Data Anda",
  "data.lead": "Anda dapat melihat apa yang kami simpan tentang Anda, membawa salinannya, atau menghapusnya.",
  "data.exportTitle": "Unduh data saya",
  "data.exportText": "Satu file JSON berisi semua yang kami simpan tentang Anda: profil, pendaftaran, ringkasan kotak masuk, tugas, persetujuan, dan pembayaran.",
  "data.exportDone": "Unduhan Anda telah dimulai.",
  "data.deleteTitle": "Hapus akun saya",
  "data.deleteWhat": "Ini menghapus:",
  "data.delete1": "akun dan akses masuk Anda",
  "data.delete2": "profil, data keluarga, sekolah, dan esai Anda",
  "data.delete3": "planner, pendaftaran, dan tugas Anda",
  "data.delete4": "kotak masuk pendaftaran beserta pesan-pesannya",
  "data.delete5": "catatan persetujuan dan koneksi ekstensi",
  "data.deleteKept": "Stripe menyimpan catatan pembayaran (jumlah, tanggal, empat digit terakhir kartu) sesuai kewajiban hukum pajak dan anti-penipuan. Kami menyimpan catatan bahwa sebuah akun telah dihapus, tanpa data pribadi.",
  "data.deleteFinal": "Tindakan ini tidak dapat dibatalkan. Sebaiknya unduh data Anda terlebih dahulu.",
  "data.deleteType": "Ketik DELETE untuk mengonfirmasi",
  "data.deleteButton": "Hapus akun saya",
  "data.rightsTitle": "Hak Anda",
  "data.rightAccess": "Dapatkan salinan data Anda dengan “Unduh data saya”.",
  "data.rightCorrect": "Perbaiki dengan mengedit {profile} Anda.",
  "data.rightDelete": "Hapus dengan “Hapus akun saya”.",
  "data.rightWithdraw": "Cabut persetujuan dengan menghapus centang pada data pencocokan beasiswa mana pun di profil Anda.",
  "data.rightObject": "Menolak, atau membatasi, cara kami memakai data Anda.",
  "data.rightPort": "Bawa data Anda ke layanan lain: unduhannya berupa file JSON standar.",
  "data.rightComplain": "Mengajukan keluhan ke otoritas perlindungan data Anda.",
  "data.contact": "Ada pertanyaan atau permintaan? Kirim email ke {email}. Kami menjawab dalam satu bulan.",
  "data.profileLink": "profil",
  "bye.title": "Akun Anda telah dihapus",
  "bye.text": "Kami telah menghapus akun dan data PathsAbroad Anda. Terima kasih telah mencoba PathsAbroad, dan semoga sukses dengan studi Anda.",
  "nf.title": "Kami tidak dapat menemukan halaman itu",
  "nf.text": "Tautannya mungkin rusak, atau halamannya telah dipindahkan.",
  "legal.contents": "Daftar isi",
  "legal.effective": "Tanggal berlaku: {date}",
  "legal.top": "Kembali ke atas",
  "err.ai_unavailable": "AI tidak tersedia saat ini. Coba lagi nanti.",
  "aiCheck.title": "Apakah ini ditulis oleh AI PathsAbroad?",
  "aiCheck.lead": "Tempel teks untuk memeriksa apakah itu jawaban dari pemandu AI atau masukan esai PathsAbroad. Setiap jawaban AI ditandai saat ditulis, dan kami menyimpan sidik jarinya (bukan teks itu sendiri).",
  "aiCheck.label": "Teks yang diperiksa",
  "aiCheck.hint": "Tempel seluruh jawaban persis seperti yang ditampilkan. Teks yang diubah atau tidak lengkap tidak akan cocok.",
  "aiCheck.empty": "Tempel teks yang ingin diperiksa.",
  "aiCheck.submit": "Periksa",
  "aiCheck.yes.title": "Ya: ditulis oleh AI PathsAbroad",
  "aiCheck.yes.text": "Teks ini cocok dengan jawaban dari AI PathsAbroad pada {date}.",
  "aiCheck.no.title": "Tidak cocok",
  "aiCheck.no.text": "Teks ini tidak cocok dengan jawaban mana pun dari AI PathsAbroad. Mungkin teks ini ditulis oleh manusia, sudah diubah, atau ditulis oleh alat lain.",
  "aiCheck.how": "Cara kerjanya: setiap jawaban AI membawa detail bertanda tangan (siapa yang menulis, kapan, dan sidik jari teks). Pemeriksaan ini membandingkan sidik jari teks yang Anda tempel dengan sidik jari jawaban AI PathsAbroad. Pemeriksaan ini tidak menampilkan apa pun tentang siswa.",
  "nav.reminders": "Pengingat",
  "rem.title": "Pengingat",
  "rem.lead": "Kami mengirim email kepada Anda tentang tenggat, balasan tawaran, dokumen yang kurang, dan keputusan. Anda juga bisa menerimanya lewat WhatsApp.",
  "rem.on": "Aktif",
  "rem.waTitle": "WhatsApp",
  "rem.waOff": "Pengingat WhatsApp belum tersedia. Pengingat email sudah berfungsi.",
  "rem.waOn": "Pengingat dikirim ke {phone} lewat WhatsApp.",
  "rem.waPhone": "Nomor WhatsApp Anda",
  "rem.waPhoneHint": "Dengan kode negara, misalnya +91 98765 43210.",
  "rem.waConsent": "Kirimkan saya pesan WhatsApp dari PathsAbroad tentang pendaftaran saya (tenggat, balasan tawaran, dokumen yang kurang, dan keputusan), beserta kode untuk mengonfirmasi nomor saya. Saya dapat berhenti kapan saja dengan membalas STOP.",
  "rem.waConsentNeeded": "Centang kotak untuk menyetujui pengingat WhatsApp.",
  "rem.waSend": "Kirim kode",
  "rem.waSent": "Kami mengirim kode 6 digit ke {phone} lewat WhatsApp. Kode berlaku selama 10 menit.",
  "rem.waCode": "Kode dari WhatsApp",
  "rem.waConfirm": "Konfirmasi",
  "rem.waResend": "Kirim kode baru",
  "rem.waOther": "Gunakan nomor lain",
  "rem.waConfirmed": "Pengingat WhatsApp aktif. Kami mengirim pesan pertama ke {phone}.",
  "rem.waStop": "Hentikan pengingat WhatsApp",
  "rem.waStopped": "Pengingat WhatsApp nonaktif. Nomor Anda sudah kami hapus.",
  "rem.waStoppedReply": "Anda menghentikan pengingat WhatsApp dengan membalas STOP. Nomor Anda sudah kami hapus.",
  "rem.waUnreachable": "WhatsApp tidak dapat mengirim ke {phone}. Periksa nomornya dan atur ulang.",
  "rem.waChanged": "Nomor WhatsApp Anda berubah, sehingga pengingat ke {phone} berhenti. Tambahkan nomor baru Anda agar tetap menerimanya.",
  "rem.phoneInvalid": "Masukkan nomor WhatsApp Anda dengan kode negara, misalnya +91 98765 43210.",
  "rem.phoneNotMobile": "Masukkan nomor ponsel.",
  "rem.phoneNotWhatsApp": "Nomor ini tidak dapat menerima pesan WhatsApp. Periksa nomornya, atau gunakan pengingat email.",
  "rem.emailTitle": "Email",
  "rem.emailLabel": "Pengingat email ke {email}",
  "rem.emailOnDone": "Pengingat email aktif.",
  "rem.emailOffDone": "Pengingat email nonaktif.",
  "rem.kindsTitle": "Hal yang akan diingatkan",
  "rem.kindDeadlines": "Tenggat",
  "rem.kindDeadlinesDesc": "Tugas dengan tanggal jatuh tempo dan tenggat beasiswa: 7, 3, dan 1 hari sebelumnya, serta pada hari H.",
  "rem.kindOffers": "Balasan tawaran",
  "rem.kindOffersDesc": "Tanggal untuk menerima atau menolak tawaran, berdasarkan email penerimaan Anda.",
  "rem.kindDocuments": "Dokumen yang kurang",
  "rem.kindDocumentsDesc": "Saat universitas menulis bahwa ada yang kurang dari pendaftaran Anda.",
  "rem.kindDecisions": "Keputusan",
  "rem.kindDecisionsDesc": "Saat universitas mengirim keputusan. Pesannya tidak pernah menyebutkan isi keputusan tersebut.",
  "rem.when": "Pengingat tiba antara pukul 09:00 dan 20:00 di zona waktu Anda ({tz}).",
  "rem.test": "Kirim pengingat uji coba",
  "rem.testSent": "Uji coba terkirim. Periksa WhatsApp atau email Anda.",
  "rem.saved": "Tersimpan.",
  "rem.recentTitle": "Pengingat terbaru",
  "rem.recentNone": "Belum ada pengingat.",
  "rem.kind.deadline": "Tenggat",
  "rem.kind.offer_reply": "Balasan tawaran",
  "rem.kind.missing_documents": "Dokumen yang kurang",
  "rem.kind.decision": "Keputusan",
  "rem.kind.scholarship": "Tenggat beasiswa",
  "rem.kind.test": "Uji coba",
  "rem.status.queued": "Mengirim",
  "rem.status.sent": "Terkirim",
  "rem.status.delivered": "Diterima",
  "rem.status.read": "Dibaca",
  "rem.status.failed": "Gagal diterima",
  "rem.channel.whatsapp": "WhatsApp",
  "rem.channel.email": "Email",
  "rem.privacy": "Pesan WhatsApp dikirim melalui WhatsApp Business Platform milik Meta. Nomor Anda disimpan terenkripsi dan dihapus saat Anda berhenti. Rinciannya ada di {privacy}.",
  "rem.privacyLink": "pemberitahuan privasi",
  "rem.parentsTitle": "Orang tua di WhatsApp",
  "rem.parentsLead": "Orang tua yang Anda bagikan halaman perkembangannya dapat menambahkan nomor WhatsApp mereka sendiri di halaman itu. Mereka hanya menerima pengingat tentang apa yang ditampilkan halaman tersebut, dan jika halaman dihentikan, pengingat mereka ikut berhenti.",
  "rem.parentRow": "Orang tua ({label})",
  "rem.parentRowNoLabel": "Orang tua",
  "rem.parentPending": "Menunggu kode",
  "rem.parentStop": "Hentikan",
  "rem.parentStoppedDone": "Dihentikan. Nomor mereka sudah dihapus.",
  "rem.parentLinkStopped": "Dihentikan bersama halaman perkembangan",
  "nav.family": "Keluarga",
  "fam.title": "Keluarga",
  "fam.lead": "Bagikan perkembangan Anda kepada orang tua, dan kirim tautan agar orang lain dapat membayar pass untuk Anda. Anda yang menentukan apa yang mereka lihat, dan Anda bisa berhenti berbagi kapan saja.",
  "fam.share.title": "Bagikan perkembangan Anda",
  "fam.share.sees": "Yang mereka lihat",
  "fam.share.see1": "Universitas pilihan Anda dan posisi setiap pendaftaran.",
  "fam.share.see2": "Tenggat yang akan datang, jika Anda mengaktifkannya.",
  "fam.share.see3": "Keputusan, jika Anda mengaktifkannya.",
  "fam.share.see4": "Pass yang Anda miliki.",
  "fam.share.never": "Mereka tidak pernah melihat esai, email, profil, detail paspor, atau chat Anda, dan mereka tidak dapat mengubah apa pun.",
  "fam.form.lang": "Bahasa halaman mereka",
  "fam.form.label": "Untuk siapa?",
  "fam.form.labelHint": "Hanya Anda yang melihat ini, misalnya Ibu atau Ayah.",
  "fam.form.deadlines": "Tampilkan tenggat yang akan datang",
  "fam.form.deadlinesNote": "Judul tugas Anda yang masih terbuka dan memiliki tanggal jatuh tempo.",
  "fam.form.decisions": "Tampilkan keputusan",
  "fam.form.decisionsNote": "Tawaran, penolakan, dan daftar tunggu. Jika dinonaktifkan, pendaftaran yang sudah diputuskan ditampilkan sebagai terkirim.",
  "fam.form.create": "Buat tautan",
  "fam.created": "Tautan Anda siap dikirim.",
  "fam.links.title": "Tautan Anda",
  "fam.links.empty": "Belum ada tautan.",
  "fam.link.view": "Halaman perkembangan",
  "fam.link.pay": "Tautan pembayaran: {plan}",
  "fam.link.for": "Untuk {label}",
  "fam.link.inLang": "Dalam {language}",
  "fam.link.until": "Berlaku sampai {date}",
  "fam.link.opened": "Terakhir dibuka {date}",
  "fam.link.notOpened": "Belum dibuka",
  "fam.link.status.active": "Aktif",
  "fam.link.status.used": "Sudah dibayar",
  "fam.link.status.expired": "Kedaluwarsa",
  "fam.link.status.revoked": "Dihentikan",
  "fam.link.copy": "Salin tautan",
  "fam.link.whatsapp": "Kirim lewat WhatsApp",
  "fam.link.email": "Kirim lewat email",
  "fam.link.stop": "Berhenti berbagi",
  "fam.link.cancel": "Batalkan tautan",
  "fam.link.edit": "Ubah yang mereka lihat",
  "fam.link.saved": "Tersimpan.",
  "fam.msg.view": "Halo! Anda bisa mengikuti pendaftaran kuliah saya di luar negeri di PathsAbroad di sini: {url}",
  "fam.msg.viewSubject": "Pendaftaran kuliah saya di luar negeri",
  "fam.msg.pay": "Halo! Maukah Anda membantu membayar pass {plan} PathsAbroad saya? Ini tautan pembayaran yang aman: {url}",
  "fam.msg.paySubject": "Pembayaran pass PathsAbroad saya",
  "fam.pay.title": "Minta orang tua membayar",
  "fam.pay.lead": "Kirim tautan pembayaran kepada siapa pun yang membiayai kuliah Anda. Pembayaran dilakukan lewat Stripe, dan pass masuk ke akun Anda. Tautan hanya berlaku satu kali, selama 14 hari.",
  "fam.pay.plan": "Paket",
  "fam.pay.create": "Buat tautan pembayaran",
  "fam.pay.covered": "Pass Anda sudah mencakup semua paket.",
  "fam.pay.buyer": "Orang yang membayar menerima tanda terima. Semua penjualan bersifat final: tidak ada pengembalian dana.",
  "fam.tooMany": "Anda sudah memiliki 10 tautan aktif jenis ini. Hentikan salah satunya terlebih dahulu.",
  "fam.view.title": "Perkembangan kuliah di luar negeri",
  "fam.view.titleName": "Perkembangan kuliah {name} di luar negeri",
  "fam.view.lead": "{name} membagikan halaman ini kepada Anda. Halaman ini menunjukkan posisi setiap pendaftaran universitas. Tidak ada yang dapat diubah di sini, dan {name} dapat berhenti berbagi kapan saja.",
  "fam.view.leadNoName": "Seorang siswa membagikan halaman ini kepada Anda. Halaman ini menunjukkan posisi setiap pendaftaran universitas. Tidak ada yang dapat diubah di sini, dan siswa tersebut dapat berhenti berbagi kapan saja.",
  "fam.view.unis": "Universitas",
  "fam.view.unisEmpty": "Belum ada universitas di daftar.",
  "fam.view.deadlines": "Akan datang",
  "fam.view.deadlinesEmpty": "Tidak ada yang jatuh tempo dalam beberapa bulan ke depan.",
  "fam.view.due": "Jatuh tempo {date}",
  "fam.view.decisionsHidden": "Keputusan tidak ditampilkan di halaman ini.",
  "fam.view.passes": "Pass PathsAbroad",
  "fam.view.passUntil": "{plan}: aktif sampai {date}",
  "fam.view.noPass": "Saat ini tidak ada pass berbayar. Jika diperlukan, siswa dapat mengirimkan tautan pembayaran kepada Anda.",
  "fam.view.updated": "Diperbarui per {date}.",
  "fam.view.about": "PathsAbroad membantu siswa memilih universitas di luar negeri, mendaftar, mengurus visa, dan menetap.",
  "fam.view.invalid.title": "Tautan ini tidak berfungsi lagi",
  "fam.view.invalid.text": "Siswa mungkin sudah berhenti berbagi, atau tautan telah kedaluwarsa. Mintalah tautan baru kepadanya.",
  "fam.wa.title": "Pengingat di WhatsApp",
  "fam.wa.lead": "Terima pesan WhatsApp dari PathsAbroad saat ada yang jatuh tempo di halaman ini. Anda hanya menerima kabar tentang apa yang {name} pilih untuk ditampilkan di sini.",
  "fam.wa.leadNoName": "Terima pesan WhatsApp dari PathsAbroad saat ada yang jatuh tempo di halaman ini. Anda hanya menerima kabar tentang apa yang dipilih siswa untuk ditampilkan di sini.",
  "fam.wa.phone": "Nomor WhatsApp Anda",
  "fam.wa.phoneHint": "Dengan kode negara, misalnya +234 803 123 4567.",
  "fam.wa.consent": "Kirimkan saya pesan WhatsApp dari PathsAbroad tentang pendaftaran {name}, beserta kode untuk mengonfirmasi nomor saya. Saya dapat berhenti kapan saja dengan membalas STOP atau dengan tombol Hentikan pengingat.",
  "fam.wa.consentNoName": "Kirimkan saya pesan WhatsApp dari PathsAbroad tentang pendaftaran siswa, beserta kode untuk mengonfirmasi nomor saya. Saya dapat berhenti kapan saja dengan membalas STOP atau dengan tombol Hentikan pengingat.",
  "fam.wa.consentNeeded": "Centang kotak untuk menyetujui pengingat WhatsApp.",
  "fam.wa.send": "Kirim kode",
  "fam.wa.sent": "Kami mengirim kode 6 digit ke {phone} lewat WhatsApp. Kode berlaku selama 10 menit.",
  "fam.wa.code": "Kode dari WhatsApp",
  "fam.wa.confirm": "Konfirmasi",
  "fam.wa.resend": "Kirim kode baru",
  "fam.wa.other": "Gunakan nomor lain",
  "fam.wa.done": "Selesai. Pengingat akan dikirim ke {phone} lewat WhatsApp. Balas STOP kapan saja untuk menghentikannya.",
  "fam.wa.phoneInvalid": "Masukkan nomor WhatsApp Anda dengan kode negara, misalnya +234 803 123 4567.",
  "fam.wa.phoneNotMobile": "Masukkan nomor ponsel.",
  "fam.wa.phoneNotWhatsApp": "Nomor ini tidak dapat menerima pesan WhatsApp. Mohon periksa nomornya.",
  "fam.wa.badCode": "Kode itu salah, atau sudah kedaluwarsa. Periksa pesan WhatsApp, atau minta kode baru.",
  "fam.wa.privacy": "Nomor Anda disimpan terenkripsi. Nomor dihapus saat Anda berhenti, atau saat siswa berhenti membagikan halaman ini.",
  "fam.status.applying": "Menyiapkan pendaftaran",
  "fam.status.submitted": "Terkirim",
  "fam.status.offer": "Tawaran",
  "fam.status.offer_conditional": "Tawaran bersyarat",
  "fam.status.waitlisted": "Dalam daftar tunggu",
  "fam.status.deferred": "Keputusan ditunda",
  "fam.status.not_admitted": "Tidak diterima",
  "fam.status.accepted": "Tawaran diterima",
  "fam.status.declined": "Tawaran ditolak",
  "fam.status.withdrawn": "Ditarik",
  "pay.title": "Bayar pass PathsAbroad",
  "pay.titleName": "Bayar pass {plan} {name}",
  "pay.lead": "{name} mengirimkan tautan ini kepada Anda untuk membayar pass {plan} PathsAbroad miliknya. Pass ini untuk akun {name}; Anda sendiri tidak memerlukan akun.",
  "pay.leadNoName": "Seorang siswa mengirimkan tautan ini kepada Anda untuk membayar pass {plan} PathsAbroad miliknya. Pass ini untuk akun siswa tersebut; Anda sendiri tidak memerlukan akun.",
  "pay.price": "Harga",
  "pay.oneTime": "Pembayaran satu kali. Tanpa perpanjangan otomatis.",
  "pay.valid": "Berlaku {months} sejak hari Anda membayar.",
  "pay.includes": "Yang termasuk",
  "pay.refund": "Semua penjualan bersifat final: tidak ada pengembalian dana. Jika siswa tidak mendapat tawaran, pass dilanjutkan ke musim berikutnya.",
  "pay.formTitle": "Bayar",
  "pay.email": "Email Anda",
  "pay.emailHint": "Untuk tanda terima Anda.",
  "pay.country": "Anda tinggal di mana?",
  "pay.startNowTitle": "Sebelum Anda membayar",
  "pay.startNow": "Mulai pass segera setelah saya membayar. Saya memahami bahwa semua penjualan bersifat final: setelah dimulai, pass tidak dapat dibatalkan atau dikembalikan dananya.",
  "pay.startNowNote": "Jika siswa tidak mendapat tawaran, pass dilanjutkan ke musim berikutnya, gratis.",
  "pay.submit": "Bayar {price} dengan Stripe",
  "pay.secure": "Stripe yang memproses pembayaran. PathsAbroad tidak pernah melihat nomor kartu Anda.",
  "pay.canceled": "Pembayaran dibatalkan. Anda tidak dikenai biaya.",
  "pay.paid.title": "Pass ini sudah dibayar",
  "pay.paid.text": "Terima kasih. Pass aktif di akun siswa, dan orang yang membayar menerima email berisi tanda terima.",
  "pay.covered.title": "Tidak ada yang perlu dibayar",
  "pay.covered.text": "Pass siswa sudah mencakup paket ini.",
  "pay.invalid.title": "Tautan pembayaran ini tidak berfungsi lagi",
  "pay.invalid.text": "Tautan mungkin sudah kedaluwarsa atau dibatalkan. Mintalah tautan baru kepada siswa.",
  "pay.done.title": "Terima kasih",
  "pay.done.waiting": "Mengonfirmasi pembayaran Anda…",
  "pay.done.ready": "Sudah dibayar. Pass {plan} aktif di akun siswa. Kami mengirim konfirmasi lewat email.",
  "pay.done.slow": "Pembayaran Anda berhasil, tetapi konfirmasinya memakan waktu lebih lama dari biasanya. Kami akan mengirim email saat sudah selesai.",
  "pay.wd.title": "Pembelian Anda",
  "pay.wd.lead": "Anda membayar pass {plan} untuk {name} pada {date}.",
  "pay.wd.leadNoName": "Anda membayar pass {plan} PathsAbroad pada {date}.",
  "pay.wd.until": "Anda dapat membatalkan dengan pengembalian dana penuh sampai {date}.",
  "pay.wd.confirm1": "Anda menerima pengembalian dana penuh, {price}, ke kartu yang Anda gunakan untuk membayar.",
  "pay.wd.confirm2": "Pass langsung berakhir di akun siswa.",
  "pay.wd.confirm3": "Kami akan mengirim tanda terima bertanggal lewat email.",
  "pay.wd.keep": "Pertahankan pass",
  "pay.wd.done": "Dana dikembalikan pada {date}. Pengembalian dana sedang dalam perjalanan ke kartu yang Anda gunakan untuk membayar.",
  "pay.wd.over": "Semua penjualan bersifat final: pembelian ini tidak dapat dibatalkan atau dikembalikan dananya.",
  "pay.wd.invalid": "Tautan pembatalan ini tidak valid.",
  "plans.askParent": "Minta orang tua membayar",
  "plans.askParentMinor": "Di bawah 18 tahun? Orang tua atau wali dapat membayar pass Anda. Kirimkan tautan pembayaran yang aman kepada mereka.",
  "pass.byParent": "Dibayar melalui tautan pembayaran Anda",
  "land.nav.label": "Di halaman ini",
  "land.nav.money": "Beasiswa",
  "land.nav.how": "Cara kerja",
  "land.nav.features": "Fitur",
  "land.nav.trust": "Privasi",
  "land.nav.pricing": "Gratis",
  "land.nav.faq": "Pertanyaan",
  "land.nav.demo": "Demo",
  "land.getStarted": "Mulai",
  "land.globe.title": "Ke mana Anda ingin pergi?",
  "land.globe.lead": "Ketuk di mana saja pada globe. Kami akan memperbesar ke universitas terdekat dan menunjukkan seperti apa universitas itu.",
  "land.globe.search": "Cari kota, negara, atau universitas",
  "land.globe.none": "Tidak ditemukan. Coba kota, negara, atau universitas.",
  "land.globe.aria": "Globe dengan {unis} universitas, berputar perlahan. Seret untuk memutarnya, gulir ke atas atau cubit untuk memperbesar, dan ketuk di mana saja untuk melihat universitas terdekat. Dengan keyboard: tombol panah memutarnya, + dan − memperbesar atau memperkecil, dan Enter menampilkan universitas yang paling dekat dengan bagian tengah.",
  "land.globe.closest": "Universitas terdekat",
  "land.globe.yourPick": "Pilihan Anda",
  "land.globe.away": "{d} dari tempat yang Anda ketuk",
  "land.globe.here": "Tepat di tempat yang Anda ketuk",
  "land.globe.km": "{n} km",
  "land.globe.close": "Tutup",
  "land.globe.rank": "Peringkat dunia",
  "land.globe.notRanked": "Tidak diperingkat",
  "land.globe.inCountry": "Di {country}",
  "land.globe.rankOf": "#{r} dari {n}",
  "land.globe.cost": "Per tahun",
  "land.globe.costOwn": "Biaya kuliah ({year}) dan biaya hidupnya",
  "land.globe.costOwn0": "Biaya kuliah dan biaya hidupnya",
  "land.globe.costEst": "Perkiraan: biaya kuliah dan biaya hidup",
  "land.globe.admit": "Tingkat penerimaan",
  "land.globe.admitYear": "Pada {year}",
  "land.globe.select": "Tingkat seleksi",
  "land.globe.sel.high": "Sangat selektif",
  "land.globe.sel.mid": "Selektif",
  "land.globe.sel.some": "Cukup selektif",
  "land.globe.sel.low": "Kurang selektif",
  "land.globe.sel.open": "Penerimaan terbuka",
  "land.globe.selRank": "Berdasarkan peringkat dunianya",
  "land.globe.public": "Negeri",
  "land.globe.private": "Swasta",
  "land.globe.cc": "Community college",
  "land.globe.taught": "Perkuliahan di {country}: {langs}",
  "land.globe.students": "{n} mahasiswa",
  "land.globe.founded": "Berdiri {year}",
  "land.globe.begin": "Mulai",
  "land.globe.demo": "Coba demo",
  "land.globe.again": "Pilih tempat lain",
  "land.hero.note": "Gratis untuk setiap siswa. Tanpa iklan, tanpa pelacakan.",
  "land.hero.signin": "Sudah punya akun? {link}",
  "land.facts.label": "PathsAbroad sekilas",
  "land.facts.unis": "{unis} universitas di {countries} negara",
  "land.facts.langs": "Dalam bahasa Inggris, Arab, Hindi, dan Indonesia",
  "land.facts.portals": "Mengisi Common App, UCAS, OUAC, dan uni-assist",
  "land.facts.ads": "Tanpa iklan, dan data Anda tidak pernah dijual",
  "land.how.title": "Dari satu ketukan di globe hingga minggu pertama Anda di luar negeri.",
  "land.how.lead": "Tujuh langkah, satu aplikasi. Di setiap langkah, inilah yang Anda lakukan dan yang dikerjakan PathsAbroad untuk Anda.",
  "land.how.step": "Langkah {n} dari {total}",
  "land.how.you": "Anda",
  "land.how.s1.title": "Pilih tempat yang ingin Anda tuju untuk kuliah",
  "land.how.s1.time": "Sekitar satu menit",
  "land.how.s1.text": "Semuanya dimulai dari globe. Ketuk titik-titik yang bersinar, atau cari kota, negara, atau universitas: {unis} universitas di {countries} negara, masing-masing di lokasi sebenarnya.",
  "land.how.s1.you": "Ketuk setiap tempat yang menarik perhatian Anda.",
  "land.how.s1.pa": "Mencari universitas terdekat dari setiap tempat, dari yang paling dekat, lengkap dengan jaraknya.",
  "land.how.s2.title": "Jawab lima pertanyaan singkat",
  "land.how.s2.time": "Sekitar dua menit",
  "land.how.s2.text": "Obrolan singkat tentang Anda dan kampung halaman, pekerjaan yang Anda inginkan, nilai Anda, bahasa Inggris Anda, dan anggaran Anda. Sebutkan “insinyur sipil” dan pemandu akan menentukan gelar yang mengantar Anda ke sana.",
  "land.how.s2.you": "Jawab dengan kata-kata Anda sendiri, atau ketuk salah satu saran.",
  "land.how.s2.pa": "Mengubah jawaban Anda menjadi profil yang dapat dicocokkan dengan setiap universitas.",
  "land.how.s3.title": "Temui pilihan yang cocok untuk Anda",
  "land.how.s3.time": "Langsung",
  "land.how.s3.text": "Pilihan yang cocok menyala di globe, diurutkan sesuai nilai, anggaran, dan tujuan Anda. Masing-masing menunjukkan alasan kecocokannya, biaya per tahun, dan peluang Anda diterima, lengkap dengan beasiswa yang sesuai untuk Anda.",
  "land.how.s3.you": "Simpan yang Anda suka, atau tambahkan universitas mana pun yang Anda mau. Akun gratis menyimpan daftar Anda.",
  "land.how.s3.pa": "Jujur soal peluang Anda: kemungkinan besar, cocok, atau ambisius.",
  "land.how.s4.title": "Ikuti rencana Anda, selangkah demi selangkah",
  "land.how.s4.time": "Seiring berjalannya waktu",
  "land.how.s4.text": "Beranda selalu menampilkan langkah berikutnya dan apa yang akan datang: dokumen, surat rekomendasi, esai, dan biaya untuk setiap universitas, berurutan menurut tanggal. Pemandu AI menemani Anda di setiap langkah. Esai Anda dimulai dari catatan Anda sendiri, dan Anda mendapat masukan, bukan tulis ulang.",
  "land.how.s4.you": "Kerjakan langkah berikutnya kapan pun Anda siap.",
  "land.how.s4.pa": "Menjaga semua tanggal tetap berurutan dan, jika Anda mau, mengingatkan Anda lewat WhatsApp atau email.",
  "land.how.s5.title": "Isi formulir dalam hitungan detik, lalu kirim",
  "land.how.s5.time": "Hitungan detik per halaman",
  "land.how.s5.text": "Di Common App, UCAS, OUAC, dan uni-assist, tekan “Isi halaman ini” dan ekstensi Chrome PathsAbroad memasukkan jawaban yang sudah Anda berikan. Anda memeriksa setiap kolom, menulis esai sendiri, dan menekan kirim.",
  "land.how.s5.you": "Periksa setiap kolom, lalu kirim dan bayar di situs universitas itu sendiri.",
  "land.how.s5.pa": "Mengisi apa yang sudah Anda sampaikan. Tidak pernah esai atau kata sandi Anda, dan tidak pernah menekan kirim atau bayar.",
  "land.how.s6.title": "Terima kabar di satu tempat",
  "land.how.s6.time": "Kapan pun kabar tiba",
  "land.how.s6.text": "Universitas menulis ke alamat PathsAbroad Anda sendiri. Keputusan, undangan wawancara, dan permintaan dokumen dipilah begitu tiba, dan langkah berikutnya masuk ke daftar Anda. Keluarga Anda dapat mengikuti perkembangan lewat halaman yang hanya bisa dibaca.",
  "land.how.s6.you": "Baca kabarnya dan balas tawaran Anda.",
  "land.how.s6.pa": "Memilah setiap email dan mengambil tanggal serta langkah berikutnya.",
  "land.how.s7.title": "Bersiap berangkat",
  "land.how.s7.time": "Setelah Anda mendapat tawaran",
  "land.how.s7.text": "Daftar periksa visa Anda, dengan tautan ke sumber resmi, ditambah pendanaan dari dalam dan luar negeri, tempat tinggal, makanan, pekerjaan mahasiswa, dan minggu-minggu pertama Anda. Informasi umum, bukan nasihat imigrasi atau hukum.",
  "land.how.s7.you": "Terima tawaran Anda dan kerjakan daftar Anda.",
  "land.how.s7.pa": "Menunjukkan langkah-langkah untuk tempat tujuan Anda, dan memperingatkan Anda ketika aturan visa berdampak pada kewarganegaraan Anda.",
  "land.money.eyebrow": "Beasiswa",
  "land.money.title": "Kami mencarikan dananya. Setiap beasiswa, diperiksa untuk Anda.",
  "land.money.lead": "Beasiswa untuk mahasiswa internasional tersebar di ratusan situs pemerintah dan yayasan. PathsAbroad memeriksa {n} di antaranya di {countries} negara sesuai kewarganegaraan, jenjang, dan tujuan Anda, lalu menunjukkan nilai masing-masing.",
  "land.money.s1": "beasiswa dan hibah, diperiksa untuk setiap siswa",
  "land.money.s2": "per tahun: nilai terbesar dari salah satunya",
  "land.money.s3": "negara, dengan beasiswa pemerintahnya dan pemberi dana internasional besar",
  "land.money.ex_eyebrow": "Contoh",
  "land.money.ex_who": "Amina, dari Yordania, ingin S2 di Kanada, Inggris, atau Jerman",
  "land.money.ex_v": "{n} beasiswa yang bisa ia daftar, bernilai hingga {amt} per tahun",
  "land.money.peryear": "{amt} per tahun",
  "land.money.eu": "Eropa",
  "land.money.intl": "Internasional",
  "land.money.cta": "Lihat beasiswa yang bisa Anda dapatkan",
  "land.money.fine": "Nilai dihitung per tahun, dari halaman resmi masing-masing program. Jika suatu program membayar “biaya kuliah penuh”, kami menghitungnya dengan biaya umum dan menyebutnya perkiraan. Beasiswa biasanya tidak dapat digabungkan. Diperiksa Oktober 2026.",
  "land.how.d.where": "Di mana Anda membayangkan diri Anda?",
  "land.how.d.continue": "Lanjut ({n})",
  "land.how.d.guide": "Pemandu AI",
  "land.how.d.career": "Anda ingin bekerja sebagai apa? Dari situ saya akan menentukan gelar yang tepat.",
  "land.how.d.civil": "Insinyur sipil",
  "land.how.d.level": "Untuk menjadi insinyur sipil, langkah berikutnya yang umum setelah gelar sarjana adalah S2. Apakah saya lanjutkan dengan itu?",
  "land.how.d.yes": "Ya",
  "land.how.d.finding": "Mencari pilihan yang cocok untuk Anda…",
  "land.how.d.scholar": "3 beasiswa cocok untuk Anda",
  "land.how.d.save": "Simpan daftar saya",
  "land.how.d.next": "Berikutnya: Dapatkan 3 rekomendasi. Ketuk dan saya akan memandu Anda.",
  "land.how.d.ask": "Tanya",
  "land.how.d.task": "Dapatkan 3 rekomendasi",
  "land.how.d.due": "Jatuh tempo dalam 2 hari",
  "land.how.d.doIt": "Kerjakan sekarang",
  "land.how.d.coming": "Akan datang",
  "land.how.d.deadline": "Tenggat pendaftaran: {school}",
  "land.how.d.inDays": "dalam {n} hari",
  "land.how.d.trip": "Perjalanan Anda",
  "land.how.d.starts": "Kuliah dimulai bulan September",
  "land.how.d.visa": "Daftar periksa visa Anda",
  "land.features.title": "Semua untuk kuliah di luar negeri, di satu tempat.",
  "land.features.lead": "Begini tampilannya bagi seorang siswa contoh, Amina dari Yordania.",
  "land.match.eyebrow": "Temukan yang cocok",
  "land.match.title": "Universitas yang cocok untuk Anda, dengan peluang yang jujur.",
  "land.match.text": "Beri tahu PathsAbroad nilai, anggaran, dan tujuan Anda. Aplikasi ini menyarankan universitas yang cocok, lengkap dengan biaya per tahun dan peluang Anda di masing-masing: kemungkinan besar, cocok, atau ambisius.",
  "land.match.p1": "Lihat alasan setiap universitas cocok untuk Anda, dan berapa biayanya.",
  "land.match.p2": "Beasiswa terbaik Anda, dicocokkan dengan profil Anda.",
  "land.match.p3": "Tambahkan universitas mana pun, termasuk yang tidak kami sarankan.",
  "land.apply.eyebrow": "Daftar",
  "land.apply.title": "Isi formulir pendaftaran dalam hitungan detik. Kirim sendiri.",
  "land.apply.text": "Ekstensi Chrome PathsAbroad memasukkan jawaban tersimpan Anda ke Common App, UCAS, OUAC, dan uni-assist saat Anda menekan “Isi halaman ini”. Anda memeriksa setiap kolom.",
  "land.apply.p3": "Hanya berfungsi saat Anda menekan tombolnya, dan tidak aktif di situs visa dan situs pemerintah.",
  "land.inbox.eyebrow": "Kotak masuk",
  "land.inbox.title": "Setiap email penerimaan, dipilah untuk Anda.",
  "land.inbox.text": "Gunakan alamat email PathsAbroad Anda sendiri di portal pendaftaran. Keputusan, undangan wawancara, dan permintaan dokumen dipilah, dan langkah berikutnya masuk ke daftar tugas Anda.",
  "land.inbox.p1": "Tanggal dan langkah berikutnya diambil dari setiap email.",
  "land.inbox.p2": "Pengingat sebelum setiap tenggat, jika Anda mau.",
  "land.inbox.p3": "Email lengkap disimpan terenkripsi selama 30 hari, lalu dihapus.",
  "land.ai.title": "Pemandu AI yang menjelaskan, dan tidak pernah menulis untuk Anda.",
  "land.ai.text": "Tanyakan tentang program studi, biaya, atau visa dan dapatkan jawaban yang jelas, selalu berlabel AI. Setiap esai dimulai dengan catatan dari jawaban Anda sendiri; Anda yang menulisnya, lalu mendapat masukan, bukan esai yang ditulis ulang. AI gratis untuk setiap siswa.",
  "land.reminders.title": "Pengingat lewat WhatsApp atau email.",
  "land.reminders.text": "Terima pesan 7, 3, dan 1 hari sebelum tenggat, serta pada hari H. Balas STOP untuk menghentikannya.",
  "land.visa.title": "Langkah visa dan minggu-minggu pertama Anda.",
  "land.visa.text": "Daftar periksa untuk setiap negara tujuan dengan tautan ke sumber resmi, lalu tempat tinggal, makanan, dan pekerjaan mahasiswa. Informasi umum, bukan nasihat imigrasi atau hukum.",
  "land.family.title": "Ajak keluarga Anda.",
  "land.family.text": "Bagikan halaman perkembangan yang hanya bisa dibaca kepada orang tua atau siapa pun yang Anda pilih. Berhenti berbagi kapan saja.",
  "land.lang.title": "Dalam bahasa Anda.",
  "land.lang.text": "Gunakan PathsAbroad dalam bahasa Inggris, Arab, Hindi, atau Indonesia, dan ganti kapan saja.",
  "land.trust.title": "Dibuat untuk melindungi siswa.",
  "land.trust.lead": "Nomor paspor, nilai, dan data keluarga adalah beberapa hal paling pribadi yang Anda bagikan. Begini cara PathsAbroad menjaganya tetap aman.",
  "land.trust.enc.title": "Dienkripsi sebelum disimpan",
  "land.trust.enc.text": "Nomor paspor, tanggal lahir, penghasilan keluarga, semua yang Anda simpan di perencana, dan email penerimaan Anda dienkripsi dengan AES-256-GCM. Basis data hanya menyimpan versi yang diacak.",
  "land.trust.rls.title": "Hanya Anda yang dapat melihat catatan Anda",
  "land.trust.rls.text": "Setiap baris di basis data dikunci untuk pemiliknya dengan keamanan tingkat baris, sehingga tidak ada siswa yang dapat membaca data siswa lain.",
  "land.trust.redact.title": "Detail pribadi tidak masuk ke AI",
  "land.trust.redact.text": "Nomor paspor, tanggal lahir, nomor telepon, email, dan alamat dihapus sebelum apa pun dikirim ke AI. Ras, agama, dan penghasilan keluarga tidak pernah dikirim.",
  "land.trust.ai.title": "Teks AI selalu berlabel",
  "land.trust.ai.text": "Semua yang ditulis AI ditandai sebagai AI, dan siapa pun dapat memeriksa apakah suatu teks berasal dari PathsAbroad.",
  "land.trust.aiCheck": "Periksa teks",
  "land.trust.mfa.text": "Tambahkan kode dari aplikasi autentikator, agar kata sandi yang dicuri saja tidak cukup.",
  "land.trust.help.title": "Bantuan saat dibutuhkan",
  "land.trust.help.text": "Jika suatu pesan menunjukkan seseorang mungkin dalam bahaya, pemandu AI membalas dengan layanan krisis untuk negara mereka.",
  "land.trust.data.title": "Data Anda, pilihan Anda",
  "land.trust.data.text": "Unduh semuanya, atau hapus akun Anda, kapan saja. Tidak ada yang dijual atau dipakai untuk iklan.",
  "land.price.title": "Gratis untuk setiap siswa.",
  "land.price.lead": "Tanpa pass, tanpa langganan, tanpa kartu. Semua di PathsAbroad gratis bagi siswa yang akan kuliah di negara lain.",
  "land.price.from": "Anda berasal dari mana?",
  "land.price.to": "Di mana Anda ingin kuliah?",
  "land.price.chooseFrom": "Pilih negara Anda",
  "land.price.chooseTo": "Pilih negara",
  "land.price.notSure": "Belum yakin",
  "land.price.pick": "Jawab kedua pertanyaan untuk melihat harga Anda.",
  "land.price.yours": "Harga Anda untuk kuliah di {country}",
  "land.price.yoursAny": "Harga Anda",
  "land.price.freeNote": "Semuanya, tanpa batas waktu",
  "land.price.how": "Cara kami dibayar: beberapa universitas dan layanan mahasiswa (pinjaman, tempat tinggal, rekening terblokir) membayar PathsAbroad sejumlah biaya saat seorang siswa mendaftar atau bergabung lewat kami. Anda tidak pernah dikenai biaya tambahan, dan hal ini tidak pernah mengubah pilihan yang cocok untuk Anda: pilihan itu diurutkan hanya berdasarkan seberapa cocok universitasnya dengan Anda.",
  "land.price.abroad": "PathsAbroad dibuat untuk kuliah di luar negara Anda sendiri, jadi kami tidak menampilkan universitas di negara asal Anda.",
  "land.price.for": "Satu kali bayar, berlaku {months}",
  "land.price.usd": "Harga dalam dolar AS, dan Anda selalu melihat harga Anda sebelum membayar.",
  "land.price.parents": "Orang tua dapat membayar untuk Anda lewat tautan yang aman.",
  "land.cta.free": "Mulai gratis",
  "land.cta.planner": "Coba perencana",
  "land.faq.title": "Pertanyaan dan jawabannya.",
  "land.faq.q1": "Apakah PathsAbroad gratis?",
  "land.faq.a1": "Ya, sepenuhnya: pencarian universitas, peluang Anda, pemandu AI, Autopilot, bantuan esai, setiap pendaftaran beasiswa, ekstensi Chrome, kotak masuk pendaftaran, serta bantuan visa dan kedatangan. Universitas dan layanan mahasiswa yang membayar kami, bukan siswa.",
  "land.faq.q2": "Apakah PathsAbroad mendaftar untuk saya?",
  "land.faq.a2": "Tidak. Anda memilih universitas, menulis esai sendiri, serta mengirim dan membayar setiap pendaftaran sendiri. PathsAbroad mengisi data tersimpan Anda, memulai setiap esai dengan catatan dari jawaban Anda, dan membantu Anda tetap teratur.",
  "land.faq.q3": "Apakah ini nasihat imigrasi atau hukum?",
  "land.faq.a3": "Bukan. Informasi visa ditautkan ke sumber resmi dan merupakan informasi umum, bukan nasihat imigrasi atau hukum. Selalu periksa situs web resmi untuk situasi Anda.",
  "land.faq.q4": "Universitas apa saja yang bisa saya temukan?",
  "land.faq.a4": "{unis} universitas di {countries} negara, termasuk Amerika Serikat, Inggris, Kanada, Australia, dan Jerman. PathsAbroad dibuat untuk kuliah di luar negeri, jadi universitas di negara Anda sendiri tidak ditampilkan. Anda juga bisa menambahkan universitas mana pun sendiri.",
  "land.faq.q5": "Bagaimana jika saya di bawah 18 tahun?",
  "land.faq.a5": "Orang tua atau wali menyetujui akun Anda sebelum Anda dapat menyimpan data, dan beberapa pertanyaan profil yang sensitif tetap dinonaktifkan.",
  "land.faq.q6": "Bagaimana PathsAbroad menghasilkan uang?",
  "land.faq.a6": "Beberapa universitas dan layanan mahasiswa membayar kami sejumlah biaya saat seorang siswa mendaftar atau bergabung lewat PathsAbroad. Anda tidak pernah membayar kami, dan biaya itu tidak pernah mengubah universitas mana yang kami cocokkan dengan Anda.",
  "land.faq.q7": "Apakah orang tua saya bisa melihat perkembangan saya?",
  "land.faq.a7": "Hanya jika Anda mau. Anda dapat membagikan halaman baca-saja kepada orang tua atau wali, dan menghentikan pembagian kapan saja.",
  "land.faq.q8": "Apa yang terjadi pada data saya?",
  "land.faq.a8": "Jawaban yang sensitif dienkripsi, dan tidak ada yang dijual atau dipakai untuk iklan. Anda dapat mengunduh atau menghapus semuanya dari akun Anda.",
  "land.final.title": "Mulai perjalanan Anda hari ini.",
  "land.final.text": "Buat akun gratis, atau coba planner-nya dulu.",
  "land.demo.example": "Contoh",
  "land.demo.matches": "Kecocokan Anda",
  "land.demo.inbox": "Kotak masuk pendaftaran",
  "land.demo.decision": "Keputusan",
  "land.demo.nextReply": "Langkah berikutnya ditambahkan ke daftar Anda",
  "land.demo.whatsapp": "WhatsApp",
  "land.demo.reminder": "Tersisa 3 hari untuk membalas tawaran Anda dari {school}.",
  "land.demo.all": "Semua",
  "land.demo.likely": "Kemungkinan besar",
  "land.demo.fit": "Cocok",
  "land.demo.ambitious": "Ambisius",
  "land.demo.estimate": "Peluang hanyalah perkiraan, bukan janji.",
  "land.demo.firstName": "Nama depan",
  "land.demo.lastName": "Nama belakang",
  "land.demo.citizenship": "Kewarganegaraan",
  "land.demo.essay": "Esai pribadi",
  "land.demo.youWrite": "Anda yang menulis ini",
  "land.demo.submit": "Kirim",
  "land.demo.youSubmit": "Anda yang menekan kirim",
  "land.demo.fill": "Isi halaman ini",
  "land.demo.filled": "3 kolom terisi",
  "land.demo.offer": "Anda mendapat tawaran tempat.",
  "land.demo.interview": "Wawancara",
  "land.demo.interviewText": "Pilih waktu untuk wawancara Anda.",
  "land.demo.missing": "Dokumen belum ada",
  "land.demo.missingText": "Unggah hasil tes bahasa Inggris Anda.",
  "land.demo.todo": "Ditambahkan ke daftar tugas Anda:",
  "land.demo.aiQ": "Apa arti tawaran bersyarat?",
  "land.demo.aiA": "Universitas akan menerima Anda setelah Anda memenuhi syarat dalam surat Anda, biasanya nilai akhir atau skor tes bahasa Inggris.",
  "land.demo.visa1": "Surat tawaran",
  "land.demo.visa2": "Bukti dana",
  "land.demo.visa3": "Asuransi kesehatan",
  "land.demo.visa4": "Buat janji temu visa",
  "land.demo.parentView": "Yang dilihat orang tua Anda",
  "land.demo.youSee": "Yang Anda lihat",
  "land.demo.stored": "Yang disimpan database",
};
